/*
  core-js and regenerator-runtime should be included via .babelrc
  https://babeljs.io/docs/en/babel-preset-env
  [
    "@babel/preset-env", {
      "useBuiltIns": "usage", << should read from .browserslistrc
      "corejs": 3 << and inclucde all the core-js stuff for those browsers
                     including regenerator-runtime
    }
  ]
*/

// window.fetch
import "whatwg-fetch";

import { polyfill } from "es6-promise";
polyfill();

(function(arr) {
  arr.forEach(function(item) {
    if (item.hasOwnProperty("remove")) {
      return;
    }
    Object.defineProperty(item, "remove", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function remove() {
        if (this.parentNode === null) {
          return;
        }
        this.parentNode.removeChild(this);
      },
    });
  });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);
